
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-icons/font/bootstrap-icons.css'
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue-apexcharts'
import VueTour from 'vue-tour'
import Vuelidate from 'vuelidate'
import KnobControl from 'vue-knob-control'
import VueDraggable from 'vue-draggable'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueStringFilter from 'vue-string-filter'
// import VueRouter from 'vue-router'
import vco from "v-click-outside"

import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import axios from "axios";
import VueAxios from "vue-axios";
import VeeValidate from "vee-validate";
import JsonExcel from 'vue-json-excel'

//live debugging on
Vue.config.devtools = true

Vue.component('downloadExcel', JsonExcel)
Vue.component('pagination', require('laravel-vue-pagination'));

Vue.use(VueAxios, axios);

Vue.use(vco)

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid"
  }
});

// Vue.use(VueRouter)
Vue.use(VueStringFilter)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(Vuelidate)
Vue.use(VueTour)
Vue.use(KnobControl)
Vue.use(VueDraggable)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)


VeeValidate.Validator.extend("verify_password", {
  getMessage: field =>
      `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  window.__app__ = app
}
